import {computed, ref} from 'vue'
import {defineStore} from 'pinia'
import {cpApi, type UserSummary} from '@/api'

export const useControlPanelUsersStore = defineStore('controlPanelUsers', () => {
  const users = ref<UserSummary[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)
  const hasUsers = computed(() => users.value.length > 0)

  function reset() {
    users.value = []
    error.value = null
  }

  async function loadUsers() {
    isLoading.value = true
    error.value = null
    try {
      users.value = await cpApi.users.list()
    } catch (reason) {
      const status = (reason as {response?: {status?: number}})?.response?.status
      if (status === 401 || status === 403) reset()
      error.value = reason instanceof Error ? reason.message : 'Request failed'
    } finally {
      isLoading.value = false
    }
  }

  async function createUser(email: string, password: string) {
    const created = await cpApi.users.create(email, password)
    users.value = [...users.value, created]
  }

  async function updateUser(userId: number, changes: {email?: string; password?: string}) {
    const updated = await cpApi.users.update(userId, changes)
    users.value = users.value.map((user) => (user.user_id === userId ? updated : user))
  }

  return {users, isLoading, error, hasUsers, loadUsers, createUser, updateUser, reset}
})
